// export const BASEURL = `https://brij-api-v1.empirecinemas.com/`;

export const BASEURL = `https://platinumcinemas-api.nuviotech.co`;

// export const ImageS3URL = `https://images.brijimages.com/`;
export const IMGBASEURL = `https://platinumcinemas-api.nuviotech.co`;

export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;
export const PLATINUM = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjAxYjM3ODg3LWIyZjgtNDUzZS1iZWUyLTZjZTMzYzlhZTE5NyIsImlhdCI6MTc0NjA4MDEyNX0.oxlipee6q7R3-QtbtVSThsKChQoOX5DVZNyNe6dTvT0`
export const TOKEN = PLATINUM



// WEBPACK FOOTER //
// ./src/config/index.js